import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBarsTwo2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"bars-two-2, menu, nav"} maskId="square-filled-radius-0-stroke-1-IconBarsTwo2"><path fillRule="evenodd" clipRule="evenodd" d="M2 7H22V8H2V7ZM2 16H15V17H2V16Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconBarsTwo2;
